export const WORKFLOWTASKS_STATUS = [
  {
    name: "Pending",
    value: 0,
  },
  {
    name: "Approved",
    value: 2,
  },
  {
    name: "Declined",
    value: 3,
  },
  {
    name: "Closed",
    value: 4,
  },
];

export const T_TRANSACTION_REVERSAL = "transaction_reversal";
export const T_LOAN_WRITE_OFF = "loan_writeoff";
export const T_LOAN_DISBURSEMENT = "loan_disbursement";
export const T_LOAN_DISBURSEMENT_REQUEST = "loan_disbursement_reversal";
export const T_LOAN_APPROVAL = "loan_approval";
export const T_SHARE_PURCHASE_REVERSAL = "share_purchase_reversal";
export const T_RECEIVABLE_REVERSAL = "receivable_reversal";
export const T_PAYABLE_REVERSAL = "payable_reversal";
export const T_LOAN_TOPUP = "loan_topup";
export const T_ASSET_PURCHASE_REVERSAL = "asset_purchase_reversal";
export const T_DIVIDENDS_PAYABLE_REVERSAL = "dividends_payable_reversal";
export const T_SHARE_TRANSFER_REVERSAL = "share_transfer_reversal";
export const T_TAX_APPROVAL_REVERSAL = "tax_approval_reversal";

export const WORKFLOW_PROCESS = [
  {
    name: "Transaction Reversal",
    value: "transaction_reversal",
  },
  {
    name: "Loan Write Off",
    value: "loan_writeoff",
  },
  {
    name: "Loan Disbursement",
    value: "loan_disbursement",
  },
  {
    name: "Reverse Disbursement Request",
    value: "loan_disbursement_reversal",
  },
  {
    name: "Loan Approval",
    value: "loan_approval",
  },
  {
    name: "Loan Topup",
    value: "loan_topup",
  },
  {
    name: "Share Purchase Reversal",
    value: "share_purchase_reversal",
  },
  {
    name: "Receivable Reversal",
    value: "receivable_reversal",
  },
  {
    name: "Payable Reversal",
    value: "payable_reversal",
  },
  {
    name: "Asset Purchase Reversal",
    value: "asset_purchase_reversal",
  },
  {
    name: "Asset Sale Reversal",
    value: "asset_sale_reversal",
  },
  {
    name: "Client Approval",
    value: "client_registration_approval",
  },
  {
    name: "Client Account Activation",
    value: "client_account_activation",
  },
  {
    name: "Dividends Payable Reversal",
    value: T_DIVIDENDS_PAYABLE_REVERSAL,
  },
  {
    name: "Share Transfer Reversal",
    value: T_SHARE_TRANSFER_REVERSAL,
  },
  {
    name: "Tax Approval Reversal",
    value: T_TAX_APPROVAL_REVERSAL,
  },
];
